import React, { useEffect, useState } from "react";
import styled from "styled-components";

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme, gapAndColorInputCheckbox }) => (gapAndColorInputCheckbox ? theme.spacing["2xs"] : "2.1rem")};
  color: ${({ theme }) => theme.colors.gray.dark};
  width: fit-content;

  label {
    display: flex;
    align-items: center;
    gap: 1.375rem;
    padding: ${({ theme }) => theme.spacing.xs}rem 0;
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    color: ${({ theme }) => theme.colors.gray.text_base};

    input[type="checkbox"] {
      display: none;
    }
  }

  .ref-input {
    display: inline-block;
    position: relative;
    height: 1.375rem;
    width: 1.375rem;
    border-radius: ${({ theme }) => theme.spacing["3xs"]};
    border: 0.0625rem solid
      ${({ theme, gapAndColorInputCheckbox }) => (gapAndColorInputCheckbox ? theme.colors.secondary.health_green : theme.colors.gray.dark)} !important;
    border: 0.0625rem solid ${({ theme, error }) => (error ? "red" : theme.colors.gray.dark)} !important;
  }

  label input:checked + .ref-input:after {
    content: " ";
    border: solid white;
    border-width: 0 ${({ theme }) => theme.spacing["4xs"]} ${({ theme }) => theme.spacing["4xs"]} 0;
    transform: rotate(40deg);
    width: ${({ theme }) => theme.spacing["2xs"]};
    height: 15px;
    position: absolute;
    top: 0px;
    left: 0.3125rem;
    display: block;
  }

  label input:checked ~ .ref-input {
    border-color: ${({ theme }) => theme.colors.secondary.health_green};
    background-color: ${({ theme }) => theme.colors.secondary.health_green};
  }

  .input-checkbox {
    display: none !important;
  }
`;

/**
 * Componente de input de checkbox.
 * @param {object} props - Propriedades do componente.
 * @param {Array<{ label: string, value: any }>} props.options - Opções disponíveis para seleção.
 * @param {(value: any) => void} props.setValue - Função de callback para definir os valores selecionados.
 * @param {Array<any>} props.currentValues - Valores atualmente selecionados.
 * @param {boolean} [props.required] - Indica se a seleção é obrigatória.
 * @param {boolean} [props.error=false] - Indica se ocorreu um erro no input.
 * @returns {JSX.Element} O componente InputCheckbox.
 */
export default function InputCheckbox({ options, setValue, currentValues, required, error = false }) {
  const [disabledIndex, setDisabledIndex] = useState(null);

  useEffect(() => {
    const inputs = document.querySelectorAll(".ref-input");

      if (error) {
       
      inputs.forEach((input) => {
        input.style.borderColor = "#BC1C1C";
      });
    } else {
      inputs.forEach((input) => {
        input.style.borderColor = "#515151";
      });
    }
  }, [error]);

  function handleClick(e) {
    if (!e.target.value) return;
    const answer = { key: e.target.id, value: e.target.value };
    if (answer.value === "Não possuo deficiência") {
      if (disabledIndex) {
        setDisabledIndex(null);
      } else {
        setDisabledIndex(answer.key);
        currentValues = [];
      }
    }
    if (currentValues.some((value) => value.key === answer.key)) {
      setValue(currentValues.filter((value) => value.key !== answer.key));
    } else {
      setValue([...currentValues, answer]);
    }
  }

  return (
    <InputWrapper>
      {options.map((option, index) => {
        return (
          <label key={index} onClick={handleClick}>
            <input
              className={error ? "error-label" : ""}
              type="checkbox"
              id={option.key}
              value={option.value}
              checked={currentValues.some((value) => value.key === option.key)}
              readOnly
              required={required}
              key={option.key}
              disabled={disabledIndex !== null && disabledIndex !== option.key}
            />
            <div className="ref-input"></div>
            {option.value}
          </label>
        );
      })}
    </InputWrapper>
  );
}
